var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _hoverTimeout, _handleBlur, _handleFocus, _handleDocumentKeyDown, _handleMouseOver, _handleMouseOut, _handleDocumentClick, _show, show_fn, _hide, hide_fn, _renderTooltipBody, renderTooltipBody_fn, _renderWithIcon, renderWithIcon_fn, _renderWithoutIcon, renderWithoutIcon_fn;
import { animateTo, stopAnimations } from "@horizon/common/helpers";
import { HznIconInfoCircle } from "@horizon/icons/individual";
import { HznInline } from "@horizon/inline";
import { LitElement, html } from "@horizon/base";
import { property, query } from "@horizon/base/decorators";
import { ScopedElementsMixin } from "@open-wc/scoped-elements/lit-element.js";
import { SlPopup } from "@horizon/common/components";
import TooltipStyles from "./tooltip.css.js";
class HznTooltip extends ScopedElementsMixin(LitElement) {
  constructor() {
    super(...arguments);
    /**
     * @private
     */
    __privateAdd(this, _show);
    /**
     * @private
     */
    __privateAdd(this, _hide);
    /**
     * @private
     */
    __privateAdd(this, _renderTooltipBody);
    /**
     * @private
     */
    __privateAdd(this, _renderWithIcon);
    /**
     * @private
     */
    __privateAdd(this, _renderWithoutIcon);
    __privateAdd(this, _hoverTimeout, void 0);
    this.content = "";
    this.hoist = false;
    this.icon = "outline";
    /**
     * @private
     */
    __privateAdd(this, _handleBlur, () => {
      clearTimeout(__privateGet(this, _hoverTimeout));
      __privateSet(this, _hoverTimeout, window.setTimeout(() => __privateMethod(this, _hide, hide_fn).call(this), 50));
    });
    /**
     * @private
     */
    __privateAdd(this, _handleFocus, () => {
      clearTimeout(__privateGet(this, _hoverTimeout));
      __privateSet(this, _hoverTimeout, window.setTimeout(() => __privateMethod(this, _show, show_fn).call(this), 50));
    });
    /**
     * @private
     */
    __privateAdd(this, _handleDocumentKeyDown, (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        __privateMethod(this, _hide, hide_fn).call(this);
      }
    });
    /**
     * @private
     */
    __privateAdd(this, _handleMouseOver, (e) => {
      if (e.target.disabled)
        return;
      clearTimeout(__privateGet(this, _hoverTimeout));
      __privateSet(this, _hoverTimeout, window.setTimeout(() => __privateMethod(this, _show, show_fn).call(this), 50));
    });
    /**
     * @private
     */
    __privateAdd(this, _handleMouseOut, () => {
      clearTimeout(__privateGet(this, _hoverTimeout));
      __privateSet(this, _hoverTimeout, window.setTimeout(() => __privateMethod(this, _hide, hide_fn).call(this), 50));
    });
    /**
     * @private
     */
    __privateAdd(this, _handleDocumentClick, (event) => {
      if (!event.composedPath().includes(this)) {
        __privateMethod(this, _hide, hide_fn).call(this);
      }
    });
  }
  /**
   * @private
   */
  static get scopedElements() {
    return {
      "hzn-icon-info-circle": HznIconInfoCircle,
      "hzn-inline": HznInline,
      "hzn-popup": SlPopup
    };
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.icon === "none") {
      this.removeEventListener("blur", __privateGet(this, _handleBlur), true);
      this.removeEventListener("focus", __privateGet(this, _handleFocus), true);
      this.removeEventListener("mouseleave", __privateGet(this, _handleMouseOut));
      this.removeEventListener("mouseenter", __privateGet(this, _handleMouseOver));
    } else {
      this.trigger.removeEventListener("blur", __privateGet(this, _handleBlur), true);
      this.trigger.removeEventListener("focus", __privateGet(this, _handleFocus), true);
      this.removeEventListener("mouseleave", __privateGet(this, _handleMouseOut));
      this.trigger.removeEventListener("mouseenter", __privateGet(this, _handleMouseOver));
    }
    document.removeEventListener("keydown", __privateGet(this, _handleDocumentKeyDown));
  }
  firstUpdated() {
    if (this.icon === "none") {
      this.addEventListener("blur", __privateGet(this, _handleBlur), true);
      this.addEventListener("focus", __privateGet(this, _handleFocus), true);
      this.addEventListener("mouseleave", __privateGet(this, _handleMouseOut));
      this.addEventListener("mouseenter", __privateGet(this, _handleMouseOver));
    } else {
      this.trigger.addEventListener("blur", __privateGet(this, _handleBlur));
      this.trigger.addEventListener("focus", __privateGet(this, _handleFocus), true);
      this.addEventListener("mouseleave", __privateGet(this, _handleMouseOut));
      this.trigger.addEventListener("mouseenter", __privateGet(this, _handleMouseOver));
    }
  }
  render() {
    return html`${this.icon === "none" ? __privateMethod(this, _renderWithoutIcon, renderWithoutIcon_fn).call(this) : __privateMethod(this, _renderWithIcon, renderWithIcon_fn).call(this)}`;
  }
}
_hoverTimeout = new WeakMap();
_handleBlur = new WeakMap();
_handleFocus = new WeakMap();
_handleDocumentKeyDown = new WeakMap();
_handleMouseOver = new WeakMap();
_handleMouseOut = new WeakMap();
_handleDocumentClick = new WeakMap();
_show = new WeakSet();
show_fn = async function() {
  if (this.content.trim() === "")
    return;
  document.addEventListener("keydown", __privateGet(this, _handleDocumentKeyDown));
  await stopAnimations(this.body);
  this.body.hidden = false;
  this.popup.active = true;
  await animateTo(this.popup.popup, [
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1 }
  ], { duration: 350, easing: "ease" });
  this.body.setAttribute("aria-live", "polite");
  this.popup.reposition();
  document.addEventListener("click", __privateGet(this, _handleDocumentClick));
};
_hide = new WeakSet();
hide_fn = async function() {
  document.removeEventListener("keydown", __privateGet(this, _handleDocumentKeyDown));
  document.removeEventListener("click", __privateGet(this, _handleDocumentClick));
  await stopAnimations(this.body);
  await animateTo(this.popup.popup, [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.8 }
  ], { duration: 150, easing: "ease" });
  this.body.setAttribute("aria-live", "off");
  this.popup.active = false;
  this.body.hidden = true;
};
_renderTooltipBody = new WeakSet();
renderTooltipBody_fn = function() {
  return html`<div class="tooltip-body" role="tooltip">
      <div class="tooltip-content">${this.content}</div>
    </div>`;
};
_renderWithIcon = new WeakSet();
renderWithIcon_fn = function() {
  const iconVariant = this.icon === "fill" || this.icon === "filled" ? "filled" : "stroked";
  return html`<hzn-inline align-y="center">
      <slot></slot>
      <hzn-popup
        arrow
        class="tooltip"
        distance=8
        flip
        hover-bridge
        placement="top"
        shift
        strategy="${this.hoist ? "fixed" : "absolute"}"
      >
        <span slot="anchor" aria-describedby="tooltip" class="tooltip-trigger" tabindex="0">
          <hzn-icon-info-circle variant="${iconVariant}"></hzn-icon-info-circle>
        </span>
        ${__privateMethod(this, _renderTooltipBody, renderTooltipBody_fn).call(this)}
      </hzn-popup>
    </hzn-inline>`;
};
_renderWithoutIcon = new WeakSet();
renderWithoutIcon_fn = function() {
  return html`
      <hzn-popup
        arrow
        class="tooltip"
        distance=8
        flip
        hover-bridge
        placement="top"
        shift
        strategy="${this.hoist ? "fixed" : "absolute"}"
      >
        <slot slot="anchor" aria-describedby="tooltip" class="tooltip-trigger"></slot>
        ${__privateMethod(this, _renderTooltipBody, renderTooltipBody_fn).call(this)}
      </hzn-popup>`;
};
/**
 * @private
 */
HznTooltip.styles = [TooltipStyles];
__decorateClass([
  query(".tooltip-body")
], HznTooltip.prototype, "body", 2);
__decorateClass([
  query(".tooltip")
], HznTooltip.prototype, "popup", 2);
__decorateClass([
  query(".tooltip-trigger")
], HznTooltip.prototype, "trigger", 2);
__decorateClass([
  property({ type: String })
], HznTooltip.prototype, "content", 2);
__decorateClass([
  property({ type: Boolean })
], HznTooltip.prototype, "hoist", 2);
__decorateClass([
  property({ type: String })
], HznTooltip.prototype, "icon", 2);
export {
  HznTooltip
};
//# sourceMappingURL=tooltip.js.map
